/**
 * Per-claim filters for V4 extrinsic notes and contradiction groups.
 */

/**
 * @param {Record<string, string>|null|undefined} extrinsicNotes
 * @param {string|number} claimId
 * @returns {string|null}
 */
export function getExtrinsicNoteForClaim(extrinsicNotes, claimId) {
    if (!extrinsicNotes || claimId == null) return null;
    const note = extrinsicNotes[String(claimId)];
    if (note == null || String(note).trim() === '') return null;
    return String(note).trim();
}

/**
 * @param {Record<string, string>|null|undefined} extrinsicNotes
 * @param {string|number} claimId
 * @returns {boolean}
 */
export function hasExtrinsicCorrection(extrinsicNotes, claimId) {
    return getExtrinsicNoteForClaim(extrinsicNotes, claimId) != null;
}

/**
 * @param {object[]} contradictions
 * @param {string|number} claimId
 * @returns {object[]}
 */
export function getContradictionsForClaim(contradictions, claimId) {
    if (!Array.isArray(contradictions) || claimId == null) return [];
    const idStr = String(claimId);
    return contradictions.filter((c) => String(c?.claimId ?? '') === idStr);
}

/**
 * @param {object[]} contradictions
 * @param {string|number} claimId
 * @returns {number}
 */
export function getContradictionCountForClaim(contradictions, claimId) {
    return getContradictionsForClaim(contradictions, claimId).length;
}
